import api from '../services/api';

/**
 * Get a specific receipt by number
 */
export const getReceiptByNumber = (receiptNumber) => {
  return api.get(`/sales/receipt/${receiptNumber}/`);
};

/**
 * Update a receipt (payment method, notes)
 */
export const updateReceipt = (receiptNumber, data) => {
  return api.put(`/sales/receipt/${receiptNumber}/update/`, data);
};

/**
 * Delete a receipt
 */
export const deleteReceipt = (receiptNumber) => {
  return api.delete(`/sales/receipt/${receiptNumber}/delete/`);
};

/**
 * Get all receipts (sales) for the market
 */
export const getAllReceipts = () => {
  return api.get('/sales/');
};

/**
 * Get all receipts across all pagination pages
 */
export const getAllReceiptsAllPages = async () => {
  let url = '/sales/';
  let allResults = [];

  while (url) {
    const response = await api.get(url);
    const data = response.data;

    if (Array.isArray(data)) {
      allResults = allResults.concat(data);
      break;
    }

    const pageResults = Array.isArray(data?.results) ? data.results : [];
    allResults = allResults.concat(pageResults);

    // DRF next may be absolute or start with /api/. Normalize to axios-relative path.
    if (data?.next) {
      const nextPath = data.next.replace(/^https?:\/\/[^/]+/, '');
      url = nextPath.startsWith('/api/') ? nextPath.replace(/^\/api/, '') : nextPath;
    } else {
      url = null;
    }
  }

  return allResults;
};
